export default __webpack_public_path__ + "static/media/item1.630e0243.jpg";